import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  EDIT_PROFILE_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  VERIFY_EMAIL_REQUEST,
  VERIFY_TOKEN_REQUEST,
  GET_PROFILE_REQUEST,
  SEND_EMAIL_REQUEST,
} from "../constants/profileConstants";
import {
  editProfileSuccess,
  editProfileFailure,
  changePasswordSuccess,
  changePasswordFailure,
  verifyEmailSuccess,
  verifyEmailFailure,
  verifyTokenSuccess,
  verifyTokenFailure,
  getProfileSuccess,
  getProfileFailure,
  sendEmailSuccess,
  sendEmailFailure,
  getProfileRequest,
} from "../actions/profileActions";
import {
  editProfileApi,
  changePasswordApi,
  verifyEmailApi,
  verifyTokenApi,
  sendEmailApi,
  getProfileApi,
} from "../api/profileApi";

function* editProfileSaga(action) {
  try {
    const response = yield call(editProfileApi, action.payload);
    yield put(editProfileSuccess(response));
    toast.success(response?.message || "Profile updated successfully!");

    // Refresh profile data after successful update
    yield put(getProfileRequest(action.payload.oemId));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to update profile";
    yield put(editProfileFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* changePasswordSaga(action) {
  try {
    const response = yield call(changePasswordApi, action.payload);
    yield put(changePasswordSuccess(response));
    toast.success(response?.message || "Password changed successfully!");

    // Refresh profile data after successful password change
    yield put(getProfileRequest(action.payload.oemId));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to change password";
    yield put(changePasswordFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* verifyEmailSaga(action) {
  try {
    const response = yield call(verifyEmailApi, action.payload);
    if (response.status === 200) {
      yield put(verifyEmailSuccess(response));
      toast.success(
        response?.message || "Verification email sent successfully!"
      );
    } else {
      yield put(
        verifyEmailFailure(
          response?.message || "Failed to send verification email"
        )
      );
      toast.error(response?.message || "Failed to send verification email");
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to send verification email";
    yield put(verifyEmailFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* verifyTokenSaga(action) {
  try {
    const { token, email } = action.payload;
    const response = yield call(verifyTokenApi, token, email);
    yield put(verifyTokenSuccess(response));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Token verification failed";
    yield put(verifyTokenFailure(errorMessage));
  }
}

function* getProfileSaga(action) {
  try {
    const response = yield call(getProfileApi, action.payload);
    yield put(getProfileSuccess(response));
  } catch (error) {
    console.error("OEM partner API error:", error);
    yield put(getProfileFailure(error.message));
  }
}

function* sendEmailSaga(action) {
  try {
    const response = yield call(sendEmailApi, action.payload);
    yield put(sendEmailSuccess(response));
    toast.success(response?.message);
  } catch (error) {
    console.error("Send email API error:", error);
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to send email";
    yield put(sendEmailFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* profileSaga() {
  yield takeEvery(EDIT_PROFILE_REQUEST, editProfileSaga);
  yield takeEvery(CHANGE_PASSWORD_REQUEST, changePasswordSaga);
  yield takeEvery(VERIFY_EMAIL_REQUEST, verifyEmailSaga);
  yield takeEvery(VERIFY_TOKEN_REQUEST, verifyTokenSaga);
  yield takeEvery(GET_PROFILE_REQUEST, getProfileSaga);
  yield takeEvery(SEND_EMAIL_REQUEST, sendEmailSaga);
}

export default profileSaga;
